import Phaser from 'phaser';
import GameBackground from '../game/GameBackground';
import ABCyaPhaser from '@abcya/abcya_phaser';
import LevelSelectMenu from '../ui/LevelSelectMenu';
import gameData from '../gameData';
import ColorSelectMenu from '../ui/ColorSelectMenu';
import Game from './Game';
import ReviewScreen from './ReviewScreen';

export default class SelectScreen extends Phaser.Scene {
  static get KEY() { return 'SelectScreen'; }

  constructor() {
    super({ key: SelectScreen.KEY });
  }

  init() {
    this.demoPiece = null;
    this.levelMenu = null;
    this.playerCustomMenu = null;
    this.selectLabel = null;
    this.dialogShown = null;
    this.reviewBtn = null;
  }

  create() {
    GameBackground.instance.switchBg('title',true);

    this.selectLabel = ABCyaPhaser.Images.addImage(0,0,'label-level-select', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0);
    this.selectLabel.x = (this.scale.width / 2) - (this.selectLabel.width / 2);

    this.levelMenu = new LevelSelectMenu(this,gameData.gameConfigs[gameData.game].destinationData.length);
    this.levelMenu.y = this.selectLabel.getBounds().height + 20;
    this.add.existing(this.levelMenu);
    this.levelMenu.once('LEVEL_SELECTED', this.handleLevelSelect, this);

    if (gameData.gameConfigs[gameData.game].CUSTOM_PLAYER_OPTIONS === true) {
      this.playerCustomMenu = new ColorSelectMenu(this);
      this.add.existing(this.playerCustomMenu);
      this.playerCustomMenu.on('SELECT_COLOR', this.handleColorSelect, this);
    }

    if (gameData.gameConfigs[gameData.game].GAME_TITLE === 'Food Groups') {
      this.reviewBtn = ABCyaPhaser.Images.addImage(0,0,'btn-review', this, ABCyaPhaser.Images.LOCALIZATION_ATLAS).setOrigin(0)
        .setInteractive();
      this.reviewBtn.x = ((this.scale.width / 3) * 2) - (this.reviewBtn.width / 3);
      this.reviewBtn.y = this.levelMenu.y + this.levelMenu.getBounds().height;
      this.reviewBtn.once(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleReviewBtn, this);
    }
  }

  handleLevelSelect (e) {
    if (this.reviewBtn) this.reviewBtn.off(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, this.handleReviewBtn, this, true);
    gameData.curLevelIndex = e._selectedLevelIndex - 1;

    this.cleanUp(Game.KEY);
  }

  handleReviewBtn () {
    this.cleanUp(ReviewScreen.KEY);
  }

  handleColorSelect (e) {
    gameData.playerId = e._playerId;

    GameBackground.instance.updateCarColor();
  }

  cleanUp (toScreen) {
    this.scene.start(toScreen);
  }
}